import { useCallback, useEffect, useState } from 'react';
import { getAdminUnreadCount } from '../../../services/helpTicketService';

export function useAdminHelpUnread(enabled: boolean) {
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!enabled) {
      setCount(0);
      return;
    }
    try {
      const { count: n } = await getAdminUnreadCount();
      setCount(n);
    } catch {
      setCount(0);
    }
  }, [enabled]);

  useEffect(() => {
    void refresh();
    const id = setInterval(() => void refresh(), 30_000);
    return () => clearInterval(id);
  }, [refresh]);

  return { count, refresh };
}
